import { http } from "./http";

export const propertyGooglePlacesSnapshotsApi = {
  list: (params) =>
    http.get("/property-google-places-snapshots", { params }).then((r) => r.data),

  getById: (id) =>
    http.get(`/property-google-places-snapshots/${id}`).then((r) => r.data.data),

  create: (payload) =>
    http.post("/property-google-places-snapshots", payload).then((r) => r.data.data),

  syncGooglePlaces: (id) =>
    http
      .post(`/property-google-places-snapshots/${id}/google-sync`)
      .then((r) => r.data.data),
};
